var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getReportDefinitions from "../../requests/reports/getReportDefinitions";
/**
 *
 */
var GetReportDefinitonsCommand = /** @class */ (function (_super) {
    __extends(GetReportDefinitonsCommand, _super);
    function GetReportDefinitonsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation OrganisationModel
     * @param reportCollection ReportCollection
     * @return {*}
     */
    GetReportDefinitonsCommand.prototype.execute = function (organisation, reportCollection) {
        this.organisation = organisation;
        this.reportCollection = reportCollection;
        var promise = getReportDefinitions(organisation.id);
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    /**
     *
     * @param response
     */
    GetReportDefinitonsCommand.prototype.then = function (response) {
        this.reportCollection.reset(false);
        this.reportCollection.addAll(response);
    };
    return GetReportDefinitonsCommand;
}(Command));
export default GetReportDefinitonsCommand;
